const REGEX_INT = /\d+/g;

const parseDigits = (string: string) => (string.match(REGEX_INT) || []).join('');

export const formatDate = (date: string, separator: string) => {
    const concatDate = (value: string) => (value.length ? `${separator}${value}` : '');
    const digits = parseDigits(date);

    const year = digits.substring(4, 8);
    const month = digits.substring(2, 4);
    const day = digits.substring(0, 2);

    return day + concatDate(month) + concatDate(year);
};
